import { arrayNiceString, taxonomyToArray } from '../utilities/index.js';

/* Hooks into the Astra theme and adds Ajax Search Results to the Astra Search Box in the header from WP API*/
document.addEventListener('DOMContentLoaded', function() {
  
  // Create content element
  const searchFieldDesktop = document.querySelector('.search-field-desktop');
  const $content = document.createElement('ul');
  $content.className = 'ajax-result-box';
  searchFieldDesktop?.parentNode.insertBefore($content, searchFieldDesktop.nextSibling);
  $content.style.display = 'none';

  let currentFocusIndex = -1;

  const hotPhraseResult = (wordToCompare) => {
    let result = {containsKeyword: false, responsePhrase: '', singleResult: false};
    const phrases = [
      {
        'phraseList': ['login', 'log in', 'sign in', 'signin', 'sign up', 'signup','log','customer login','logging in'],
        'response' : "<li><a href='https://login.pointclickcare.com/home/userLogin.xhtml' ><span class='search-field-result-title'>Looking to log into PointClickCare: Click Here</span></li>",
        'singleResult': true
      },
      {
        'phraseList': ['career', 'careers', 'career opportunities', 'work at pointclickcare'],
        'response' : "<li><a href='https://careers.pointclickcare.com' target='_blank'><span class='search-field-result-title'>Looking for current career opportunities at PointClickCare: Click Here</span></li>",
        'singleResult': true
      },
      {
        'phraseList': ['pdpm','patient-driven payment model', 'patient driven payment model', 'pdpm help'],
        'response' : "<li><a href='/pdpm-with-confidence/' target='_blank' ><span class='search-field-result-title'>Looking for PDPM Information, Resources or Help? Click Here</span></li>",
        'singleResult': true
      },
      {
        'phraseList': ['poc','point of care', 'poc login', 'point of care login','point of care sign in','point of care customer login'],
        'response' : "<li><a href='https://www4.pointclickcare.com/poc/userLogin.xhtml' target='_blank' ><span class='search-field-result-title'>Looking to log into Point of Care: Click Here</span></li>",
        'singleResult': true
      },
      {
        'phraseList': ['marketplace', 'market place', 'market'],
        'response' : "<li><a href='https://marketplace.pointclickcare.com/' target='_blank' ><span class='search-field-result-title'>Looking for the PointClickCare Marketplace: Click Here</span></li>"
      },
      {
        'phraseList': ['developer', 'developer program', 'amplify', 'pointclickcare developer program'],
        'response' : "<li><a href='https://developer.pointclickcare.com/' target='_blank' ><span class='search-field-result-title'>Looking for the PointClickCare Developer Program: Click Here</span></li>"
      },
      {
        'phraseList': ['contact', 'contact us', 'get in touch'],
        'response' : "<li><a href='/company/contact-us/' target='_blank' ><span class='search-field-result-title'>Looking to Contact PointClickCare: Click Here</span></li>"
      },
      {
        'phraseList': ['partner', 'partner program', 'partner exchange', 'pointclickcare partner'],
        'response' : "<li><a href='https://partnerexchange.pointclickcare.com/' target='_blank' ><span class='search-field-result-title'>Looking for the PointClickCare Partner Exchange Network: Click Here</span></li>",
      },
    ];

    for (let i= 0; i<phrases.length; i++) {
      let phraseList = phrases[i].phraseList;
      for (let j = 0; j < phraseList.length; j++) {
        if (wordToCompare.indexOf(phraseList[j]) > -1) {
          result.containsKeyword = true;
          result.responsePhrase = phrases[i].response;
          result.singleResult = phrases[i].singleResult;
          break;
        }
      }
      if (result.containsKeyword) return result;
    }

    return result;
  }

  document.querySelectorAll('.search-field').forEach(field => {
    field.addEventListener('input', function(e) {
      const $inputSearch = this.value.toLowerCase();
      let ajaxurl = wpObj.autoSearchAPI + $inputSearch;
      let blogSearch = this.classList.contains('search-field-blog');
      if (blogSearch) ajaxurl += '&limit_to_posts=1';
      
      if ($inputSearch.length >= 3) {
        let hotPhrase = hotPhraseResult($inputSearch);

        if (hotPhrase.containsKeyword) {
          if (hotPhrase.singleResult) {
            $content.style.display = 'block';
            $content.innerHTML = '';
            $content.insertAdjacentHTML('beforeend', hotPhrase.responsePhrase);
            return;
          }
        }
        
        // Add loading class
        $content.classList.add('loading');
        
        fetch(ajaxurl)
          .then(response => response.json())
          .then(data => {
            $content.classList.remove('loading');
            $content.innerHTML = '';

            if (hotPhrase.containsKeyword) {
              $content.insertAdjacentHTML('beforeend', hotPhrase.responsePhrase);
            }

            data.forEach((item, i) => {
              const permalink = item.link;
              const industries = item.industries;
              const tags = item.tags;
              const categories = item.categories.filter(value => value.slug !== 'uncategorized');
              const topics = item.topics;
              const segment = item.segment;
              const contentTypes = item.contentTypes;
              const title = item.title;
              const id = 'result-' + item.id;
              
              let result = `<li id="${id}"><a href="${permalink}" data-index="${i}"><span class="search-field-result-title">${title}</span>`;

              if (categories.length > 0) {
                result += ` <span class="search-field-result-type">(${arrayNiceString(taxonomyToArray(categories))})</span>`;
              }

              if (tags.length > 0 && !blogSearch) {
                result += ` <span class="search-field-result-type">(${arrayNiceString(taxonomyToArray(tags))})</span>`;
              }

              if (industries.length > 0) {
                result += ` <span class="search-field-result-type">(${arrayNiceString(taxonomyToArray(industries))})</span>`;
              }
              
              if (topics.length > 0) {
                result += ` <span class="search-field-result-type">(${arrayNiceString(taxonomyToArray(topics))})</span>`;
              }
              
              if (segment.length > 0) {
                result += ` <span class="search-field-result-type">(${arrayNiceString(taxonomyToArray(segment))})</span>`;
              }
              
              if (contentTypes.length > 0) {
                result += ` <span class="search-field-result-type">(${arrayNiceString(taxonomyToArray(contentTypes))})</span>`;
              }

              result += "</a></li>";

              $content.insertAdjacentHTML('beforeend', result);
            });

            $content.querySelectorAll('li a').forEach(a => {
              a.addEventListener('focus', function(e) {
                currentFocusIndex = parseInt(this.dataset.index);
              });
            });
            
            setFocusTarget();
            $content.style.display = 'block';
          });
      } else {
        $content.style.display = 'none';
        $content.innerHTML = '';
      }
    });
  });

  const searchIcon = document.querySelector('.search-icon');
  if (searchIcon) {
    searchIcon.addEventListener('click', function(e) {
      e.preventDefault();
      $content.innerHTML = '';
      document.querySelector('.search-field').value = '';
      const searchFormDesktop = document.getElementById('search-form-desktop');
      searchFormDesktop.style.display = 'block';
      setTimeout(() => {
        document.getElementById('search-field-desktop').focus();
      }, 100);
      document.addEventListener('keydown', closeSearchBar);
    });
  }

  const searchClose = document.querySelector('.search-close');
  if (searchClose) {
    searchClose.addEventListener('click', function(e) {
      $content.style.display = 'none';
      const searchFormDesktop = document.getElementById('search-form-desktop');
      searchFormDesktop.style.display = 'none';
      setTimeout(() => {
        $content.innerHTML = '';
      }, 100);
      document.removeEventListener('keydown', closeSearchBar);
      document.removeEventListener('keydown', navigateSearchList);
    });
  }

  function setFocusTarget() {
    document.removeEventListener('keydown', navigateSearchList);
    currentFocusIndex = -1;
    document.addEventListener('keydown', navigateSearchList);
  }

  function navigateSearchList(e) {
    removeActive();
    if (e.key !== 'Tab') {
      if(e.key === 'ArrowUp') {
        e.preventDefault();
        currentFocusIndex--;
      }
      if(e.key === 'ArrowDown') {
        e.preventDefault();
        currentFocusIndex++;
      }
      if (currentFocusIndex < -1) currentFocusIndex = $content.children.length - 1;
      if (currentFocusIndex > $content.children.length - 1) currentFocusIndex = -1;
      if (currentFocusIndex === -1) {
        document.getElementById('search-field-desktop').focus();
      } else {
        addActive();
      }
    }
  }

  function closeSearchBar(e) {
    if (e.key === 'Escape') {
      $content.style.display = 'none';
      const searchFormDesktop = document.getElementById('search-form-desktop');
      searchFormDesktop.style.display = 'none';
      setTimeout(() => {
        $content.innerHTML = '';
      }, 100);
      document.removeEventListener('keydown', closeSearchBar);
      document.removeEventListener('keydown', navigateSearchList);
    }
  }

  function addActive() {
    if (!$content) return false;
    const link = $content.children[currentFocusIndex].querySelector('a');
    if (link) {
      link.classList.add('highlight');
      link.focus();
    }
  }

  function removeActive() {
    if (currentFocusIndex >= 0 && $content.children[currentFocusIndex]) {
      const link = $content.children[currentFocusIndex].querySelector('a');
      if (link) {
        link.classList.remove('highlight');
      }
    }
  }
});